import React, { useEffect } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import SvgIcon from "../../assets/images/pet-avatar.svg";
import dumy_dog from "../../assets/images/dumy_dog.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { getSinglePet, messageClean } from "redux-store/pets/pet.slice";
import { useParams, useNavigate } from "react-router-dom";
import { singlePet } from "redux-store/pets/pet.selector";
import { getPetTests, petTestsClean } from "redux-store/lab-tests/tests.slice";
import { test } from "redux-store/lab-tests/tests.selecter";
import { Link } from "react-router-dom";
import UserLabResult from "components/user/user-lab-result/UserLabResult";
import PetArchivePopUp from "./PetArchivePopUp";
import { user } from "redux-store/user/user.selectors";

export default function DetailsPage() {
  const { petID } = useParams();
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const params = useParams();
  const navigate = useNavigate();
  const pet = useSelector(singlePet);
  const tests = useSelector(test);
  const loginUser = useSelector(user);
  useEffect(() => {
    if (params.petID) {
      dispatch(petTestsClean());
      dispatch(getSinglePet(params.petID));
      dispatch(getPetTests(params.petID));
    }
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEdit = () => {
    let path = "edit";
    if (loginUser?.isAdmin) {
      navigate(`/admin/pets/edit-pet-details/${path}/${petID}`);
    } else {
      navigate(`/user/pets/edit-pet-details/${path}/${petID}`);
    }
  };

  function calculateAgeInMonths(birthdate: any) {
    const today = new Date();
    const birthdateObj = new Date(birthdate);

    // Calculate the difference in years and months
    const yearsDiff = today.getFullYear() - birthdateObj.getFullYear();
    const monthsDiff = today.getMonth() - birthdateObj.getMonth();

    // Convert the years and months difference to months
    const totalMonths = yearsDiff * 12 + monthsDiff;

    return totalMonths;
  }

  return (
    <div className="tw-px-6 tw-flex tw-flex-col tw-gap-4">
      <Link to="/user/pets">
        <div className="tw-hidden lg:tw-flex tw-flex-row tw-items-center tw-gap-x-2 tw-text-[18px]">
          <KeyboardBackspaceIcon />
          <span>BACK TO PETS</span>
        </div>
      </Link>
      <div className="sm:tw-pl-[10%] lg:tw-mx-20 tw-pt-10 tw-p-2 lg:tw-p-10 tw-flex tw-flex-col gap-4 tw-py-3 tw-bg-[#FFFFFF] tw-rounded-2xl tw-shadow-3xl">
        <div className="tw-flex tw-gap-6 tw-items-center">
          <img
            src={pet?.photo ? pet.photo : dumy_dog}
            className=" tw-rounded-[50%] tw-h-[60px] tw-w-[60px] tw-object-cover"
            alt=""
          />
          <span className="tw-text-[20px] md:tw-text-[26px] lg:tw-text-3xl tw-font-bold">
            {pet?.petName && pet?.petName !== "" ? pet?.petName : "None"}
          </span>
        </div>
        <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-2 xl:tw-gap-5 tw-text-[22px] tw-mx-2 lg:tw-mx-10 2xl:tw-mx-24">
          <div className="tw-flex tw-flex-col tw-flex-1">
            <span className="tw-text-[18px] md:tw-text-[22px] lg:tw-text-3xl tw-font-bold">Breed</span>
            <span className="tw-text-[16px] md:tw-text-[20px] tw-font-light">
              {pet?.petBreed && pet?.petBreed !== "" ? pet?.petBreed : "None"}
            </span>
          </div>
          <div className="tw-flex tw-flex-col tw-flex-1">
            <span className=" tw-text-[18px] md:tw-text-[22px] lg:tw-text-3xl tw-font-bold">Gender</span>
            <span className="tw-text-[16px] md:tw-text-[20px] tw-font-light">
              {pet?.petGender && pet?.petGender !== "" ? pet?.petGender : "None"}
            </span>
          </div>
          <div className="tw-flex tw-flex-col tw-flex-1">
            <span className="tw-text-[18px] md:tw-text-[22px] lg:tw-text-3xl tw-font-bold">Weight</span>
            <span className="tw-text-[16px] md:tw-text-[20px] tw-font-light">
              {pet?.petWeight && pet?.petWeight !== "" ? pet?.petWeight : "None"}
            </span>
          </div>
          <div className="tw-flex tw-flex-col tw-flex-1">
            <span className="tw-text-[18px] md:tw-text-[22px] lg:tw-text-3xl tw-font-bold">Age</span>
            <span className="tw-text-[16px] md:tw-text-[20px] tw-font-light">
              {calculateAgeInMonths(pet?.birthDate) < 1
                ? "less than month"
                : calculateAgeInMonths(pet?.birthDate) + "  Months"}
            </span>
          </div>
        </div>
        <div className="tw-pt-4 lg:tw-pt-7 tw-flex tw-flex-col min-[375px]:tw-flex-row">
          <button
            className="tw-text-white tw-text-[16px] md:tw-text-[20px] tw-border-2 tw-px-[36px] sm:tw-px-[40px] tw-py-2 lg:tw-py-3 tw-rounded-[10px] tw-border-reddishOrange tw-bg-reddishOrange hover:tw-text-white hover:tw-bg-darkRed hover:tw-border-darkRed tw-cursor-pointer"
            onClick={handleEdit}
          >
            Edit Details
          </button>
          {/* <button
            className="tw-border-2 tw-w-full min-[375px]:tw-w-auto tw-text-[16px] md:tw-text-[20px] tw-rounded-[10px] tw-mt-5 min-[375px]:tw-mt-0 min-[375px]:tw-ml-5 tw-px-[36px] sm:tw-px-[40px] tw-py-2 lg:tw-py-3 tw-border-black tw-text-black hover:tw-bg-slate-200 hover:tw-border-slate-200 hover:tw-text-black cursor-pointer"
            onClick={handleClickOpen}
          >
            Archive Pet
          </button> */}
        </div>
      </div>
      <div className="tw-font-bold tw-mx-2 lg:tw-mx-16 tw-my-3 lg:tw-my-8">
        <div className="tw-text-2xl lg:tw-text-[35px]">Lab Test Results</div>
        <div className="tw-text-base tw-text-reddishOrange tw-font-normal tw-my-3">
          Results for the Premium option take up to 10 business days, while the Essential option can take up to 21
          business days from the time we receive your sample. You will receive an email when your report is ready.
        </div>
      </div>

      <UserLabResult labTests={tests} />
      <PetArchivePopUp open={open} handleClose={handleClose} />
    </div>
  );
}
